import algoliasearch from 'algoliasearch';
import {createInMemoryCache} from '@algolia/cache-in-memory';

const isK8s = process.env.K8S_DEPLOYMENT === 'true';
const algoliaApplicationId = () => {
  if (isK8s) {
    return __ENV__ === 'production'
      ? process.env.ALGOLIA_V2_APPLICATION_ID_PROD
      : process.env.ALGOLIA_V2_APPLICATION_ID_STAGING;
  }
  return process.env.ALGOLIA_V2_APPLICATION_ID;
};
const algoliaSearchApiKey = () => {
  if (isK8s) {
    return __ENV__ === 'production'
      ? process.env.ALGOLIA_V2_SEARCH_API_KEY_PROD
      : process.env.ALGOLIA_V2_SEARCH_API_KEY_STAGING;
  }
  return process.env.ALGOLIA_V2_SEARCH_API_KEY;
};

export const initializeAlgoliaClient = () => {
  return algoliasearch(algoliaApplicationId(), algoliaSearchApiKey(), {
    responsesCache: createInMemoryCache(),

    // Caches Promises with the same request payload
    requestsCache: createInMemoryCache({serializable: false})
  });
};
